<template>
  <div>
    <audience-template-card-overview :template="template" />

    <v-sheet rounded class="py-2 px-6 mt-4">
      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Zdroj
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-select
            hide-details
            :items="pixels"
            item-text="name"
            item-value="id"
            outlined
            v-model="includedSource"
            return-object
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Upřesnit
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-select
            disabled
            hide-details
            :items="['Četnost je větší nebo rovno 2']"
            outlined
            :value="'Četnost je větší nebo rovno 2'"
          ></v-select>
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Retence
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            outlined
            hide-details
            suffix="dny/dnů"
            type="number"
            min="1"
            v-model="includedRetention"
          />
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Stránka
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            key="included-page"
            outlined
            hide-details
            placeholder="Zadejte prodejní stránku produktu"
            v-model="includedPage"
          />
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet rounded class="py-2 px-6 mt-4">
      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Zdroj
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-select
            hide-details
            :items="pixels"
            item-text="name"
            item-value="id"
            outlined
            v-model="excludedSource"
            return-object
          ></v-select>
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Retence
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            outlined
            hide-details
            suffix="dny/dnů"
            type="number"
            min="1"
            v-model="excludedRetention"
          />
        </v-col>
      </v-row>

      <v-row row wrap>
        <v-col :xs="12" :lg="12" class="pb-0">
          <p class="body-1 font-weight-bold mb-0 navy--text text--darken-1">
            Stránka
          </p>
        </v-col>

        <v-col lg="12" class="pb-4">
          <v-text-field
            outlined
            hide-details
            placeholder="Zadejte děkovací stránku produktu"
            v-model="excludedPage"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import AudienceTemplateCardOverview from "@/components/ui/AudienceTemplateCardOverview.vue"
import includedMixin from "./includedMixin"
import excludedMixin from "./excludedMixin"

export default {
  mixins: [includedMixin, excludedMixin],
  props: {
    template: {
      type: Object,
      required: true,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  components: {
    AudienceTemplateCardOverview,
  },
  computed: {
    ...get("pixels", ["pixels"]),
  },
  methods: {
    ...call("pixels", ["loadPixels"]),
  },
  mounted() {
    this.loadPixels()
  },
}
</script>
